/* ==========================================================================
   PLEINE BULL — Recherche v2 (assets/pb-search.js)
   Sans dépendance (pas d'Alpine) : fonctionne dès le chargement de la page.
   - Index du catalogue : templates/collection.pb-index.liquid (4 requêtes ~60 Ko,
     classé par meilleures ventes), gardé en cache local 6 h.
   - Barre du header : résultats instantanés pendant la frappe.
   - Page /search : pertinence, filtres, tri, ajout panier, desktop + mobile.
   ========================================================================== */
(function () {
  'use strict';
  if (window.PBSearch) return;

  var D = document, W = window;
  var KEY = 'pb_search_idx_v3';
  var RECENT_KEY = 'pb_search_recent';
  var TTL = 6 * 3600 * 1000;          // cache index pour la barre de recherche
  var FRESH_PAGE = 20 * 60 * 1000;     // sur /search, index rafraîchi s'il a plus de 20 min
  var PER_PAGE = 24;

  /* ------------------------------------------------------------------ *
   * Catégories (déduites du type de produit Shopify)
   * ------------------------------------------------------------------ */
  var TYPE2G = {
    'steel tip': 'steel_dart', 'soft tip': 'soft_dart', 'cibles sisal': 'board_sisal',
    'cibles electroniques': 'board_elec', 'ailettes': 'flight', 'tiges': 'shaft',
    'fusion ailettes tiges': 'fusion', 'pointes acier': 'steel_point', 'pointes plastiques': 'soft_point',
    'etui': 'case', 'etuis': 'case', 'surround': 'surround', 'eclairage': 'light', 'tapis': 'mat',
    'cabinet': 'cabinet', 'pack': 'pack', 'entretien': 'care', 'accessoires': 'acc', 'custom': 'custom'
  };
  var G = {
    steel_dart: { l: 'Fléchettes steel', s: 'pointe acier', b: 16 },
    soft_dart: { l: 'Fléchettes soft', s: 'pointe plastique', b: 16 },
    board_sisal: { l: 'Cibles sisal', b: 14 },
    board_elec: { l: 'Cibles électroniques', b: 14 },
    pack: { l: 'Packs', b: 10 },
    flight: { l: 'Ailettes', b: 2 },
    shaft: { l: 'Tiges', b: 2 },
    fusion: { l: 'Ailettes + tiges', b: 2 },
    steel_point: { l: 'Pointes acier', b: 1 },
    soft_point: { l: 'Pointes soft', b: 1 },
    case: { l: 'Étuis', b: 2 },
    surround: { l: 'Surrounds', b: 3 },
    light: { l: 'Éclairages', b: 3 },
    mat: { l: 'Tapis & oches', b: 3 },
    cabinet: { l: 'Cabinets', b: 3 },
    care: { l: 'Entretien', b: 0 },
    acc: { l: 'Accessoires', b: 0 },
    custom: { l: 'Personnalisation', b: 0 },
    other: { l: 'Autres', b: 0 }
  };
  var G_ORDER = Object.keys(G);

  /* Mots de catégorie (après normalisation + singulier) */
  var NOUN = {
    flechette: 'dart', flechete: 'dart', flechet: 'dart', flech: 'dart', fleche: 'dart', dart: 'dart',
    cible: 'board', dartboard: 'board', board: 'board',
    ailette: 'flight', ailete: 'flight', flight: 'flight', plume: 'flight', aillette: 'flight', aillete: 'flight',
    illette: 'flight', ilette: 'flight', ellette: 'flight', empennage: 'flight', flite: 'flight',
    entourage: 'surround', entoura: 'surround',
    tige: 'shaft', shaft: 'shaft', stem: 'shaft',
    pointe: 'point', embout: 'point',
    etui: 'case', housse: 'case', pochette: 'case', wallet: 'case', rangement: 'case', sacoche: 'case', trousse: 'case',
    surround: 'surround', protection: 'surround', protege: 'surround', contour: 'surround', anneau: 'surround',
    eclairage: 'light', lumiere: 'light', lampe: 'light', eclairer: 'light',
    tapi: 'mat', oche: 'mat', mat: 'mat',
    cabinet: 'cabinet', armoire: 'cabinet', meuble: 'cabinet',
    pack: 'pack', kit: 'pack', coffret: 'pack',
    entretien: 'care', affuteur: 'care', aiguiseur: 'care', affutage: 'care',
    fusion: 'fusion', integre: 'fusion', integree: 'fusion'
  };
  var MOD = {
    soft: 'soft', softip: 'soft', plastique: 'soft', electronique: 'elec', electrique: 'elec',
    connecte: 'elec', connectee: 'elec', connecter: 'elec', connect: 'elec', bluetooth: 'elec', tactile: 'elec',
    steel: 'steel', steeltip: 'steel', acier: 'steel', metal: 'steel', sisal: 'sisal'
  };
  var LEVEL = {
    debutant: 'debutant', debut: 'debutant', beginner: 'debutant', enfant: 'debutant', junior: 'debutant',
    intermediaire: 'intermediaire', confirme: 'confirme', expert: 'expert', pro: 'expert', competition: 'expert'
  };
  var COLOR = {
    noir: 'noir', noire: 'noir', black: 'noir', blanc: 'blanc', blanche: 'blanc', white: 'blanc',
    rouge: 'rouge', red: 'rouge', bleu: 'bleu', bleue: 'bleu', blue: 'bleu', vert: 'vert', verte: 'vert',
    green: 'vert', jaune: 'jaune', yellow: 'jaune', rose: 'rose', pink: 'rose', violet: 'violet',
    violette: 'violet', purple: 'violet', orange: 'orange', gris: 'gris', grise: 'gris', grey: 'gris',
    gray: 'gris', or: 'or', dore: 'or', doree: 'or', gold: 'or', argent: 'argent', argente: 'argent',
    argentee: 'argent', silver: 'argent', chrome: 'argent', marron: 'marron', brown: 'marron',
    transparent: 'transparent', multicolore: 'multicolore', bronze: 'bronze',
    turquoise: 'turquoise', beige: 'beige'
  };
  /* Synonymes : un mot cherché peut correspondre à ces mots indexés */
  var SYN = {
    /* matières */
    tungsten: ['tungstene'], tungstene: ['tungsten'], brass: ['laiton'], laiton: ['brass'],
    titane: ['titanium', 'titan'], titanium: ['titane'], titan: ['titane', 'titanium'],
    alu: ['aluminium', 'aluminum'], aluminium: ['alu', 'aluminum'], aluminum: ['aluminium', 'alu'],
    carbone: ['carbon'], carbon: ['carbone'], nylon: ['nylon', 'polycarbonate'], polycarbonate: ['nylon'],
    /* longueurs de tiges / pointes */
    short: ['court', 'courte'], court: ['short', 'courte'], courte: ['court', 'short'],
    long: ['longue'], longue: ['long'], medium: ['moyen', 'moyenne'], moyen: ['medium'], moyenne: ['medium'],
    intermediate: ['intermediaire'], intermediaire: ['intermediate'], tweenie: ['tweenie'],
    /* formes d'ailettes */
    standard: ['std'], std: ['standard'], slim: ['slim'], kite: ['kite'], pear: ['poire'], poire: ['pear'],
    /* divers */
    cadeau: ['gift'], gift: ['cadeau'], grip: ['grip', 'grippe'],
    /* joueurs et surnoms */
    mvg: ['gerwen', 'mvg'], gerwen: ['mvg'], littler: ['nuke'], nuke: ['littler'],
    snakebite: ['wright'], wright: ['snakebite'], iceman: ['price'], price: ['iceman'],
    /* fautes fréquentes sur les marques que la correction automatique ne rattrape pas */
    winmo: ['winmau'], vinmau: ['winmau'], harow: ['harrow'], unicorne: ['unicorn'], mision: ['mission'],
    granbord: ['granboard'], granbaord: ['granboard'], granboarf: ['granboard'], grandboard: ['granboard'],
    wimmau: ['winmau'], wimmeau: ['winmau'], winau: ['winmau'], winneau: ['winmau'], couesoul: ['cuesoul'], ciesoul: ['cuesoul'],
    lstylr: ['lstyle'], stylr: ['style'], cosmique: ['cosmo'], mgv: ['mvg'], sbite: ['snakebite'], snake: ['snakebite'],
    '180': ['one80', '180'], precise: ['precision'], lazer: ['laser'], oxhe: ['oche'], eclairz: ['eclairage'],
    eclerage: ['eclairage'], eclairege: ['eclairage'], baril: ['barrel'], barilet: ['barrel'], barillet: ['barrel'], barel: ['barrel'],
    /* besoins décrits avec d'autres mots (recherches réelles sans résultat) */
    pied: ['support', 'trepied', 'stand'], trepied: ['support', 'stand', 'pied'], stand: ['support', 'trepied'],
    attache: ['support', 'fixation', 'mural'], fixation: ['support', 'mural', 'fix'], fixer: ['support', 'fixation', 'fix'],
    mural: ['support', 'murale'], mur: ['mural', 'murale', 'support'],
    bruit: ['silencieux', 'isolation'], antibruit: ['silencieux', 'isolation'], isolation: ['silencieux', 'phonique'],
    silence: ['silencieux'], silencer: ['silencieux'],
    compteur: ['score', 'comptage', 'autoscoring'], comptage: ['score', 'autoscoring'], calcul: ['score', 'comptage'],
    scoring: ['autoscoring', 'score', 'comptage'], scoreur: ['autoscoring', 'score'], autoscoreur: ['autoscoring'],
    autoscroring: ['autoscoring'], scoreboard: ['score', 'tableau'], score: ['score', 'tableau'],
    arrache: ['extracteur'], arracheur: ['extracteur'], extracteur: ['extracteur'],
    spin: ['spinning', 'spin'], tourne: ['spinning', 'spin'], tournant: ['spinning', 'spin'], rotatif: ['spinning', 'spin'],
    chiffon: ['entretien'], microfibre: ['entretien'], serviette: ['entretien'], nettoyage: ['entretien'],
    protecteur: ['protection'], joint: ['torique', 'joint'], toriques: ['torique'], elastic: ['torique'],
    personnalise: ['personnalisable', 'personnalise'], personalise: ['personnalisable'], perso: ['personnalisable'],
    personnalis: ['personnalisable'], personalis: ['personnalisable'], duralium: ['duralumin'], duraluminium: ['duralumin']
  };
  var STOP = { de: 1, des: 1, du: 1, la: 1, le: 1, les: 1, pour: 1, a: 1, au: 1, aux: 1, et: 1, en: 1,
    un: 1, une: 1, avec: 1, sans: 1, the: 1, of: 1, for: 1, g: 1, gr: 1, gramme: 1, mm: 1, tip: 1, mon: 1, ma: 1, me: 1, je: 1, cherche: 1,
    meilleur: 1, meilleure: 1, top: 1, best: 1, complet: 1, complete: 1, luxe: 1, jeu: 1, comment: 1, quel: 1, quelle: 1, qui: 1, sur: 1 };
  /* Mots d'accessoire : « pied cible », « support fléchettes » → on ne restreint pas aux cibles / fléchettes */
  var CTX = { support: 1, pied: 1, trepied: 1, stand: 1, fixation: 1, fixer: 1, attache: 1, mural: 1, mur: 1, silencieux: 1,
    isolation: 1, bruit: 1, antibruit: 1, extracteur: 1, arrache: 1, outil: 1, balance: 1, tableau: 1, score: 1, compteur: 1,
    calcul: 1, comptage: 1, scoring: 1, chargeur: 1, joint: 1, perforateur: 1, presentoir: 1, silencer: 1, silence: 1 };

  /* Mots de questions pratiques : pas cherchés dans les produits (« concours » ≠ « contour ») */
  var INFOW = { concour: 1, livraison: 1, frai: 1, contact: 1, contacte: 1, contacter: 1, parrainage: 1, parrain: 1, nou: 1,
    promo: 1, code: 1, reduction: 1, garantie: 1, sav: 1, retour: 1, remboursement: 1, club: 1, expedition: 1, delai: 1, coli: 1 };
  /* Questions pratiques (« frais de livraison », « contact »…) : lien direct vers la bonne page */
  var INFO = [
    { re: /livraison|expedition|frais de port|delai|colis|suivi/, l: 'Livraison & expédition', u: '/pages/livraison-expedition' },
    { re: /contact|nous joindre|telephone|joindre|\bmail\b|service client/, l: 'Nous contacter', u: '/pages/contact' },
    { re: /parrain/, l: 'Parrainage', u: '/pages/parrainage' },
    { re: /concours/, l: 'Jeu concours', u: '/pages/jeu-concours' },
    { re: /\bpromo|code reduc|reduction|bon de reduc|coupon/, l: 'Codes promo', u: '/pages/codes-promo-bons-de-reduction-pleine-bull' },
    { re: /garantie|\bsav\b|retour|rembourse/, l: 'Garanties & SAV', u: '/pages/garantie-2-ans' },
    { re: /calcul|compter les points|comptage des points|compteur|appli|application|scoreur/, l: 'Appli de score Pleine Bull (gratuite)', u: '/pages/application-scoreur-flechettes-301-501-cricket' },
    { re: /\bclubs?\b|ou jouer/, l: 'Clubs de fléchettes', u: '/pages/clubs-partenaires' },
    { re: /triple 20|fidelite|mes points/, l: 'Programme Triple 20', u: '/pages/triple-20' },
    { re: /guide|conseil|choisir|quel poids|meilleur/, l: 'Guide d’achat fléchettes', u: '/pages/guide-achat-flechettes' },
    { re: /fixer|hauteur|distance|regle|comment/, l: 'FAQ fléchettes (hauteur, distance, règles)', u: '/pages/faq-flechettes' },
    { re: /partenaire|professionnel|devis|\bpro\b.*club|carte partenaire/, l: 'Clubs & partenariats', u: '/pages/professionnels' },
    { re: /carte cadeau|cheque cadeau/, l: 'Carte cadeau', u: '/products/carte-cadeau-pleine-bull' }
  ];
  function infoLinks(raw) {
    var n = ' ' + norm(raw) + ' ', out = [];
    INFO.forEach(function (x) { if (x.re.test(n.trim()) && out.length < 3) out.push(x); });
    return out;
  }

  /* ------------------------------------------------------------------ *
   * Outils texte
   * ------------------------------------------------------------------ */
  function norm(s) {
    s = String(s == null ? '' : s).toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    s = s.replace(/[’'`´]/g, '').replace(/œ/g, 'oe').replace(/æ/g, 'ae').replace(/&/g, ' et ');
    s = s.replace(/(\d),(\d)/g, '$1.$2');
    s = s.replace(/(\d)([a-z])/g, '$1 $2').replace(/([a-z])(\d)/g, '$1 $2');
    s = s.replace(/[^a-z0-9.]+/g, ' ').replace(/(^|\s)\.+|\.+(\s|$)/g, ' ');
    return s.replace(/\s+/g, ' ').trim();
  }
  function stem(t) {
    /* pluriel : « ailettes » → « ailette », « jeux » → « jeu » ; mais « flex », « max » restent intacts */
    if (t.length > 3 && !/^\d/.test(t)) {
      if (/(aux|eux|oux)$/.test(t)) t = t.slice(0, -1);
      else if (/s$/.test(t) && !/ss$/.test(t)) t = t.slice(0, -1);
    }
    return t;
  }
  function toks(s) {
    var out = [], a = norm(s).split(' ');
    for (var i = 0; i < a.length; i++) if (a[i]) out.push(stem(a[i]));
    return out;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Distance d'édition (Damerau simplifiée), arrêt dès que > max */
  function dist(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var prev2 = null, prev = [], cur, i, j;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur = [i];
      var best = i;
      for (j = 1; j <= lb; j++) {
        var c = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + c);
        if (prev2 && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v;
        if (v < best) best = v;
      }
      if (best > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[lb];
  }
  function money(cents) {
    var n = (cents || 0) / 100;
    try { return n.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  }
  function imgUrl(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function track(ev, data) {
    try { (W.dataLayer = W.dataLayer || []).push(Object.assign({ event: ev }, data || {})); } catch (e) {}
  }

  /* ------------------------------------------------------------------ *
   * Suivi des recherches (GA4 via GTM + commandes Shopify)
   * - dataLayer : pb_search, pb_search_zero, pb_search_typed, pb_search_click,
   *   pb_search_add_to_cart, pb_search_filter, pb_search_sort, pb_search_more, pb_search_error
   * - panier : attributs cachés _pb_recherche / _pb_recherche_via, recopiés sur la commande
   *   → permet de mesurer le CA issu de la recherche directement dans Shopify.
   * ------------------------------------------------------------------ */
  var FROM_KEY = 'pb_search_from';
  function setFrom(v) { try { sessionStorage.setItem(FROM_KEY, v); } catch (e) {} }
  function takeFrom() {
    try { var v = sessionStorage.getItem(FROM_KEY) || ''; sessionStorage.removeItem(FROM_KEY); return v; } catch (e) { return ''; }
  }
  function euros(c) { return Math.round(c) / 100; }
  function prodInfo(h) {
    var it = IDX && IDX.byH ? IDX.byH[h] : null;
    return it ? { product: h, product_name: it.t, product_brand: it.v, product_category: G[it.g] ? G[it.g].l : '', price: euros(it.p), in_stock: it.a ? 'oui' : 'non' } : { product: h };
  }
  /* Mémorise sur le panier la dernière recherche qui a mené à un produit */
  function tagCart(term, via) {
    term = String(term || '').trim().slice(0, 80);
    if (!term) return;
    try {
      fetch(((W.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', {
        method: 'POST', keepalive: true, credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _pb_recherche: term, _pb_recherche_via: via } })
      }).catch(function () {});
    } catch (e) {}
  }
  function trackClick(term, el, source) {
    var data = Object.assign({ search_term: term, position: +el.getAttribute('data-pbs-pos'), source: source }, prodInfo(el.getAttribute('data-pbs-h')));
    track('pb_search_click', data);
    tagCart(term, 'clic');
  }
  function trackAdd(term, btn, source) {
    var card = btn.closest('[data-pbs-h]') || btn.closest('.pbs-card, .pbs-d__prod');
    var link = card && (card.getAttribute('data-pbs-h') ? card : card.querySelector('[data-pbs-h]'));
    var h = link ? link.getAttribute('data-pbs-h') : '';
    var pos = link ? +link.getAttribute('data-pbs-pos') : 0;
    var info = prodInfo(h);
    track('pb_search_add_to_cart', Object.assign({ search_term: term, position: pos, source: source, value: info.price || 0, currency: 'EUR' }, info));
    tagCart(term, 'ajout');
  }

  /* ------------------------------------------------------------------ *
   * Index
   * ------------------------------------------------------------------ */
  var IDX = null, loading = null;

  function themeParam() {
    var t = W.Shopify && W.Shopify.theme;
    return t && t.role && t.role !== 'main' && t.id ? '&preview_theme_id=' + t.id : '';
  }
  function pageUrl(n) {
    return '/collections/all?view=pb-index&sort_by=best-selling&page=' + n + themeParam();
  }
  function readCache() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var c = JSON.parse(raw);
      if (!c || !c.p || !c.t || !c.rk || c.theme !== themeParam()) return null;
      return c;
    } catch (e) { return null; }
  }
  function fetchPage(n) {
    var ctrl = W.AbortController ? new AbortController() : null;
    if (ctrl) setTimeout(function () { ctrl.abort(); }, 15000);
    return fetch(pageUrl(n), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined }).then(function (r) {
      if (!r.ok) throw new Error('index ' + r.status);
      return r.text();
    }).then(function (t) { return JSON.parse(t); });
  }
  function fetchAll() {
    var first = [1, 2, 3, 4].map(fetchPage);
    return Promise.all(first).then(function (pages) {
      var total = pages[0].pages || 1, more = [];
      for (var n = 5; n <= total; n++) more.push(fetchPage(n));
      return Promise.all(more).then(function (rest) { return pages.concat(rest); });
    }).then(function (pages) {
      var all = [];
      pages.forEach(function (pg) { if (pg && pg.p) all = all.concat(pg.p); });
      var c = { t: Date.now(), theme: themeParam(), p: all, rk: (pages[0] && pages[0].rk) || {} };
      try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
      return c;
    });
  }

  function build(c) {
    var vocab = {}, items = [], brands = {}, rk = c.rk || {};
    function addV(set, t) { if (!t) return; set[t] = 1; vocab[t] = (vocab[t] || 0) + 1; }
    c.p.forEach(function (p, i) {
      if (!p || !p.h) return;
      var it = {
        h: p.h, t: p.t || '', v: p.v || '', y: p.y || '', i: p.i || '',
        p: +p.p || 0, px: +p.px || 0, ca: +p.ca || 0, a: !!p.a, vc: +p.vc || 1, vid: p.vid || '',
        r: parseFloat(p.r) || 0, rc: +p.rc || 0, d: +p.d || 0, q: +p.q || 50, tu: +p.tu || 0,
        rank: i, n: norm(p.n), li: p.li || '',
        br: typeof rk[p.h] === 'number' ? rk[p.h] : null   /* position business dans sa collection (Worker) */
      };
      it.g = TYPE2G[norm(p.y)] || (/carte cadeau/i.test(it.t) ? 'other' : (norm(p.y) ? 'acc' : 'other'));
      it.tt = {}; it.ot = {};
      var tw = toks(it.t);
      tw.forEach(function (t) { addV(it.tt, t); });
      /* Mots collés : « kflex », « swisspoint », « lstyle », « graneye », « lukehumphries »… */
      for (var b = 0; b < tw.length - 1; b++) {
        var j2 = tw[b] + tw[b + 1];
        if (tw[b].length <= 6 && j2.length >= 4 && j2.length <= 16 && !/^\d+$/.test(j2)) addV(it.ot, j2);
      }
      var other = [it.v, p.y, (p.g || '').replace(/\|/g, ' '), p.o ? p.o.replace(/\|/g, ' ') : '', p.m, p.li, p.n, (p.c || '').replace(/\|/g, ' ')].join(' ');
      toks(other).forEach(function (t) { addV(it.ot, t); });
      /* Références (SKU) : « BU-50971 », « LP1201 », « D1047 » */
      String(p.k || '').split('|').forEach(function (k) {
        var nk = norm(k);
        if (!nk) return;
        addV(it.ot, nk.replace(/ /g, ''));
        nk.split(' ').forEach(function (t) { if (/\d/.test(t) && t.length >= 3) addV(it.ot, t); });
      });
      var vj = norm(it.v).replace(/ /g, '');
      if (vj) { addV(it.ot, vj); addV(it.ot, stem(vj)); brands[stem(vj)] = 1; }
      toks(it.v).forEach(function (t) { if (t.length > 2) brands[t] = 1; });
      /* Poids */
      it.w = [];
      String(p.w || '').split('|').forEach(function (w) {
        var n = parseFloat(String(w).replace(',', '.'));
        if (n > 0 && n < 60 && it.w.indexOf(n) < 0) it.w.push(n);
      });
      if (!it.w.length && (it.g === 'steel_dart' || it.g === 'soft_dart')) {
        var m = norm(it.t).match(/(?:^| )(\d{1,2}(?:\.5)?) g(?: |$)/);
        if (m) it.w.push(parseFloat(m[1]));
      }
      /* Couleurs */
      it.c = {};
      String(p.c || '').split('|').forEach(function (cc) { var k = COLOR[norm(cc)]; if (k) it.c[k] = 1; });
      Object.keys(it.tt).forEach(function (t) { if (COLOR[t]) it.c[COLOR[t]] = 1; });
      it.nt = toks(it.t).join(' ');
      items.push(it);
    });
    var vlist = Object.keys(vocab);
    var byH = {};
    items.forEach(function (it) { byH[it.h] = it; });
    return { items: items, byH: byH, vocab: vocab, vlist: vlist, brands: brands, n: items.length, t: c.t };
  }

  function load(opts) {
    opts = opts || {};
    var cached = readCache();
    var maxAge = opts.fresh ? FRESH_PAGE : TTL;
    if (cached && (Date.now() - cached.t) < maxAge) {
      if (!IDX || IDX.t !== cached.t) IDX = build(cached);
      return Promise.resolve(IDX);
    }
    if (cached && opts.allowStale) {
      if (!IDX || IDX.t !== cached.t) IDX = build(cached);
      refresh();
      return Promise.resolve(IDX);
    }
    return refresh();
  }
  function refresh() {
    if (!loading) {
      loading = fetchAll().then(function (c) {
        IDX = build(c); loading = null;
        D.dispatchEvent(new CustomEvent('pbsearch:index', { detail: IDX }));
        return IDX;
      }, function (e) { loading = null; throw e; });
    }
    return loading;
  }

  /* ------------------------------------------------------------------ *
   * Analyse de la requête
   * ------------------------------------------------------------------ */
  function parse(raw) {
    var q = { raw: String(raw || '').trim(), text: [], nouns: {}, mods: {}, colors: [], level: null,
      weight: null, tu: null, max: null, cheap: false };
    var s = q.raw.toLowerCase();
    var mt = s.match(/(\d{2}(?:[.,]\d)?)\s*%/);
    if (mt) { q.tu = parseFloat(mt[1].replace(',', '.')); s = s.replace(mt[0], ' '); }
    var mp = s.match(/(?:moins de|max(?:imum)?|sous|jusqu.?a|<|budget)\s*(\d{1,4})\s*(?:€|e|eur|euros?)?/);
    if (mp) { q.max = parseInt(mp[1], 10) * 100; s = s.replace(mp[0], ' '); }
    if (/pas cher|petit prix|bon marche|bon marché|economique|économique/.test(s)) {
      q.cheap = true; s = s.replace(/pas cher|petit prix|bon marche|bon marché|economique|économique/g, ' ');
    }
    var n = norm(s);
    /* « 18 5g » (virgule oubliée) = 18,5 g */
    n = n.replace(/(^| )(\d{1,2}) 5 (g|gr|gramme|grammes)(?= |$)/, '$1$2.5 $3');
    var mw = n.match(/(?:^| )(\d{1,2}(?:\.5)?) (?:g|gr|gramme|grammes)(?= |$)/);
    if (mw) { q.weight = parseFloat(mw[1]); n = n.replace(mw[0], ' '); }
    var words = n.split(' ').filter(Boolean).map(stem);
    q.fixed = []; q.nw = {};
    /* mots tels que tapés (pour la recherche « au mot près » dans les titres) */
    q.words = words.filter(function (w) { return !STOP[w] && !INFOW[w] && w !== 'or'; });
    words.forEach(function (w) {
      if (w === 'embout') { q.nouns.point = 1; q.mods.soft = 1; return; }
      if (INFOW[w]) return;
      if (NOUN[w]) { q.nouns[NOUN[w]] = 1; q.nw[NOUN[w]] = w; if (!q.first) q.first = NOUN[w]; return; }
      if (CTX[w]) q.ctx = true;
      /* mot de catégorie suivi de lettres en trop : « flechettettes », « fléchettesét », « ailettesss » */
      if (w.length >= 8) {
        for (var pk in NOUN) { if (pk.length >= 6 && w.indexOf(pk) === 0) { q.nouns[NOUN[pk]] = 1; q.fixed.push([w, pk]); return; } }
      }
      if (w.length >= 4 && !MOD[w] && !COLOR[w] && !LEVEL[w] && !STOP[w] && !/\d/.test(w)) {
        /* faute de frappe sur un mot de catégorie : « cibel », « flchettes », « ailete »… */
        var max = w.length >= 7 ? 2 : 1, hit = null;
        for (var k in NOUN) { if (k.length >= 4 && dist(w, k, max) <= max) { hit = k; break; } }
        if (hit) { q.nouns[NOUN[hit]] = 1; q.fixed.push([w, hit]); return; }
      }
      if (MOD[w]) { q.mods[MOD[w]] = 1; return; }
      if (LEVEL[w]) { q.level = LEVEL[w]; return; }
      if (COLOR[w] && w !== 'or') { if (q.colors.indexOf(COLOR[w]) < 0) q.colors.push(COLOR[w]); return; }
      if (w === 'or' && words.length > 1) { if (q.colors.indexOf('or') < 0) q.colors.push('or'); return; }
      if (STOP[w]) return;
      q.text.push(w);
    });
    /* Groupes de produits visés */
    var gs = [], nn = q.nouns, md = q.mods;
    function add(g) { if (gs.indexOf(g) < 0) gs.push(g); }
    /* « fléchettes pointe acier 18g » : la pointe décrit la fléchette (≠ « pointes pour fléchettes ») */
    if (nn.dart && nn.point && q.first === 'dart') delete nn.point;
    /* « éclairage pour cible », « étui fléchettes » : l'accessoire l'emporte sur la cible / les fléchettes */
    var hasAcc = nn.flight || nn.shaft || nn.point || nn['case'] || nn.surround || nn.light || nn.mat || nn.cabinet || nn.care || nn.fusion;
    /* « pied cible », « support fléchettes » : le mot cible / fléchette reste un mot à trouver dans le titre */
    if (q.ctx && nn.board) q.text.push(q.nw.board || 'cible');
    if (q.ctx && nn.dart) q.text.push(q.nw.dart || 'flechette');
    if (hasAcc || q.ctx) { delete nn.board; }
    if (q.ctx) { delete nn.dart; }
    if (nn.dart && !hasAcc && !nn.board) {
      if (md.soft || md.elec) add('soft_dart');
      if (md.steel) add('steel_dart');
      if (!md.soft && !md.elec && !md.steel) { add('steel_dart'); add('soft_dart'); }
    }
    if (nn.pack) add('pack');
    if (nn.board) {
      if (md.soft || md.elec) add('board_elec');
      if (md.sisal || md.steel) add('board_sisal');
      if (!md.soft && !md.elec && !md.sisal && !md.steel) { add('board_sisal'); add('board_elec'); }
    }
    if (nn.flight && nn.shaft) { add('fusion'); add('flight'); add('shaft'); }
    else {
      if (nn.flight) { add('flight'); add('fusion'); }
      if (nn.shaft) { add('shaft'); add('fusion'); }
    }
    if (nn.fusion) add('fusion');
    if (nn.point) {
      if (md.soft) add('soft_point');
      if (md.steel) add('steel_point');
      if (!md.soft && !md.steel) { add('steel_point'); add('soft_point'); }
    }
    ['case', 'surround', 'light', 'mat', 'cabinet', 'care'].forEach(function (k) { if (nn[k]) add(k); });
    if (!gs.length) {
      if (md.elec) add('board_elec');
      else if (md.soft) { add('soft_dart'); add('soft_point'); add('board_elec'); }
      else if (md.steel) { add('steel_dart'); add('steel_point'); add('board_sisal'); }
      else if (md.sisal) add('board_sisal');
    }
    q.groups = gs;
    /* « tiges intermédiaires » : ici c'est une longueur, pas un niveau de joueur */
    if (q.level && gs.length && gs.indexOf('steel_dart') < 0 && gs.indexOf('soft_dart') < 0 && gs.indexOf('pack') < 0) {
      q.text.push(q.level === 'expert' ? 'pro' : q.level); q.level = null;
    }
    if (q.tu) q.text = q.text.filter(function (w) { return w !== 'tungstene' && w !== 'tungsten'; });
    /* « fléchettes 22 » : nombre seul = poids si on parle de fléchettes */
    if (q.weight == null && (gs.indexOf('steel_dart') > -1 || gs.indexOf('soft_dart') > -1)) {
      for (var i = 0; i < q.text.length; i++) {
        var nb = parseFloat(q.text[i]);
        if (/^\d{2}(\.5)?$/.test(q.text[i]) && nb >= 12 && nb <= 40) { q.weight = nb; q.text.splice(i, 1); break; }
      }
    }
    return q;
  }

  /* Variantes d'un mot cherché dans le vocabulaire de l'index */
  var expCache = {};
  function expand(idx, w, isLast) {
    var key = idx.t + '|' + w + '|' + (isLast ? 1 : 0);
    if (expCache[key]) return expCache[key];
    var exact = {}, pre = {}, fuz = {}, list = idx.vlist, voc = idx.vocab, i, t;
    [w].concat(SYN[w] || []).forEach(function (s) { if (voc[s]) exact[s] = 1; });
    var numeric = /^\d/.test(w);
    if (!numeric && (w.length >= 3 || (isLast && w.length >= 2))) {
      for (i = 0; i < list.length; i++) { t = list[i]; if (t.length > w.length && t.indexOf(w) === 0) pre[t] = 1; }
    }
    var hasAny = Object.keys(exact).length || Object.keys(pre).length;
    if (!numeric && !hasAny && w.length >= 4) {
      var max = w.length >= 7 ? 2 : 1;
      for (i = 0; i < list.length; i++) {
        t = list[i];
        if (/^\d/.test(t)) continue;
        if (dist(w, t, max) <= max) fuz[t] = 1;
        else if (isLast && t.length > w.length && dist(w, t.slice(0, w.length), 1) <= 1 && w.length >= 5) fuz[t] = 1;
      }
    }
    var r = { exact: exact, pre: pre, fuz: fuz, fuzzy: !hasAny && Object.keys(fuz).length > 0, none: !hasAny && !Object.keys(fuz).length };
    expCache[key] = r;
    return r;
  }
  function tokScore(it, e) {
    var k;
    for (k in e.exact) { if (it.tt[k]) return 30; }
    for (k in e.exact) { if (it.ot[k]) return 14; }
    for (k in e.pre) { if (it.tt[k]) return 18; }
    for (k in e.pre) { if (it.ot[k]) return 9; }
    for (k in e.fuz) { if (it.tt[k]) return 12; }
    for (k in e.fuz) { if (it.ot[k]) return 6; }
    return 0;
  }
  function bizCmp(a, b) {
    var x = a.br != null ? a.br : 999, y = b.br != null ? b.br : 999;
    return x - y || a.rank - b.rank;
  }
  function closestW(ws, w) {
    var best = 99;
    for (var i = 0; i < ws.length; i++) best = Math.min(best, Math.abs(ws[i] - w));
    return best;
  }

  /* ------------------------------------------------------------------ *
   * Recherche
   * ------------------------------------------------------------------ */
  function search(idx, raw) {
    var q = parse(raw);
    /* Rien de cherchable (« concours », « frais de livraison ») : pas de produits, les liens pratiques prennent le relais */
    if (!q.text.length && !q.groups.length && q.weight == null && !q.colors.length && !q.level && !q.max && !q.tu && !q.cheap) {
      return { q: q, items: [], corrected: [], notes: [] };
    }
    /* Références : « bu 50971 » / « lp 1201 » → « bu50971 » si cette référence existe */
    for (var m = 0; m < q.text.length - 1; m++) {
      var jn = q.text[m] + q.text[m + 1];
      if (idx.vocab[jn] && (/\d/.test(jn) || !idx.vocab[q.text[m]] || !idx.vocab[q.text[m + 1]])) { q.text.splice(m, 2, jn); }
    }
    var lastPos = q.text.length - 1;
    var exps = q.text.map(function (w, i) { return expand(idx, w, i === lastPos); });
    var corrected = (q.fixed || []).slice();
    exps.forEach(function (e, i) {
      if (e.fuzzy) {
        var best = Object.keys(e.fuz).sort(function (a, b) { return (idx.vocab[b] || 0) - (idx.vocab[a] || 0); })[0];
        corrected.push([q.text[i], best]);
      }
    });
    var phrase = q.text.join(' ');
    var total = idx.n;
    /* Un mot qui est une marque reste obligatoire, même en recherche élargie (« harrows 23 ») */
    var isBrand = exps.map(function (e) {
      var k, b = idx.brands || {};
      for (k in e.exact) { if (b[k]) return true; }
      for (k in e.fuz) { if (b[k]) return true; }
      return false;
    });
    /* Poids de chaque mot : un mot rare (marque, modèle) compte plus qu'un mot courant (« 23 », « noir ») */
    var lnN = Math.log(1 + total);
    var idf = exps.map(function (e) {
      var df = 0, k;
      for (k in e.exact) df += idx.vocab[k] || 0;
      for (k in e.pre) df += idx.vocab[k] || 0;
      for (k in e.fuz) df += idx.vocab[k] || 0;
      return 0.6 + 1.4 * (Math.log(1 + total / (1 + Math.min(df, total))) / lnN);
    });

    function run(o) {
      var out = [];
      for (var i = 0; i < idx.items.length; i++) {
        var it = idx.items[i], sc = 0, hits = 0, j;
        if (o.groups && o.groups.length && o.groups.indexOf(it.g) < 0) continue;
        if (q.max && it.p > q.max) continue;
        if (q.tu && o.tu && !(it.tu && Math.abs(it.tu - q.tu) <= 1) && !it.tt[String(Math.round(q.tu))]) continue;
        if (q.weight != null && o.weight !== false) {
          if (!it.w.length) continue;
          var dw = closestW(it.w, q.weight);
          if (dw > (o.wtol || 0)) continue;
          sc += dw === 0 ? 12 : 4;
        }
        if (q.colors.length && o.colors) {
          var okc = true;
          for (j = 0; j < q.colors.length; j++) if (!it.c[q.colors[j]]) { okc = false; break; }
          if (!okc) continue;
          sc += 8;
        }
        if (q.level && o.level) {
          if (it.n.indexOf(q.level) < 0) continue;
          sc += 6;
        }
        for (j = 0; j < exps.length; j++) {
          var s = tokScore(it, exps[j]);
          if (s) { hits++; sc += s * idf[j]; }
          else if (!o.loose || isBrand[j]) { sc = -1; break; }
        }
        if (sc < 0) continue;
        if (exps.length && o.loose && hits < (o.minHits || Math.max(1, Math.ceil(exps.length / 2)))) continue;
        if (exps.length) {
          if (phrase.length > 2 && it.nt.indexOf(phrase) > -1) sc += 25;
          if (phrase.length > 2 && it.nt.indexOf(phrase) === 0) sc += 10;
          if (o.loose) sc += hits * 10;
        }
        if (o.groups && o.groups.length) sc += (o.groups.length - o.groups.indexOf(it.g)) * 2;
        sc += (G[it.g] ? G[it.g].b : 0);
        /* Classement business du Worker (ordre manuel des collections) ; à défaut, meilleures ventes Shopify */
        sc += it.br != null ? 26 * (1 - it.br / 50) : 14 * (1 - it.rank / total);
        sc += (it.q - 50) / 10;                       // priorité business (métachamp)
        if (it.rc) sc += Math.min(it.rc, 10) * 0.4 * (it.r / 5);
        if (!it.a) sc -= 45;                          // épuisé : visible mais en bas
        out.push({ it: it, s: sc });
      }
      out.sort(function (a, b) { return b.s - a.s || bizCmp(a.it, b.it); });
      return out;
    }

    var base = { groups: q.groups, colors: true, level: true, tu: true };
    var res = run(base), notes = [];
    if (!res.length && q.colors.length) {
      res = run(Object.assign({}, base, { colors: false }));
      if (res.length) notes.push('Pas de modèle ' + q.colors.join(' / ') + ' : voici les autres coloris.');
    }
    if (!res.length && q.level) {
      res = run(Object.assign({}, base, { colors: false, level: false }));
    }
    if (!res.length && q.weight != null) {
      res = run(Object.assign({}, base, { colors: false, level: false, wtol: 1 }));
      if (res.length) notes.push('Rien en ' + String(q.weight).replace('.', ',') + ' g pile : voici les poids les plus proches.');
    }
    if (!res.length && q.weight != null) {
      /* « fléchettes 30 g » : aucun modèle à ±1 g → le poids disponible le plus proche */
      var gw = q.groups.length ? q.groups : ['steel_dart', 'soft_dart'], near = 99;
      idx.items.forEach(function (it) { if (gw.indexOf(it.g) > -1 && it.w.length && it.a) near = Math.min(near, closestW(it.w, q.weight)); });
      if (near <= 8) {
        res = run(Object.assign({}, base, { groups: gw, colors: false, level: false, wtol: near }));
        if (res.length) notes.push('Pas de modèle en ' + String(q.weight).replace('.', ',') + ' g : voici les poids les plus proches.');
      }
    }
    if (!res.length && q.groups.length && exps.length) {
      res = run({ groups: null, colors: false, level: false, tu: false, wtol: 1 });
    }
    if (!res.length && exps.length > 1) {
      res = run({ groups: q.groups.length ? q.groups : null, colors: false, level: false, tu: false, weight: false, loose: true });
      if (!res.length) res = run({ groups: null, colors: false, level: false, tu: false, weight: false, loose: true });
      if (res.length) notes.push('Aucun produit ne contient tous les mots : voici les plus proches.');
    }
    if (!res.length && exps.length) {
      /* Dernier recours : on ignore les mots inconnus du catalogue (« ailettes joker » → ailettes) */
      var keepI = [], dropped = [], pool = q.groups.length ? idx.items.filter(function (it) { return q.groups.indexOf(it.g) > -1; }) : idx.items;
      q.text.forEach(function (w, i) {
        /* mot inconnu, ou qu'aucun produit de la catégorie visée ne contient */
        var useful = !exps[i].none && pool.some(function (it) { return tokScore(it, exps[i]) > 0; });
        if (useful) keepI.push(i); else dropped.push(w);
      });
      if (dropped.length && (keepI.length || q.groups.length)) {
        exps = keepI.map(function (i) { return exps[i]; });
        idf = keepI.map(function (i) { return idf[i]; });
        isBrand = keepI.map(function (i) { return isBrand[i]; });
        phrase = keepI.map(function (i) { return q.text[i]; }).join(' ');
        res = run(Object.assign({}, base, { colors: false, level: false, wtol: 2 }));
        if (!res.length && q.groups.length && exps.length) res = run({ groups: null, colors: false, level: false, tu: false, wtol: 2 });
        if (!res.length && exps.length > 1) res = run({ groups: q.groups.length ? q.groups : null, colors: false, level: false, tu: false, weight: false, loose: true });
        if (!res.length && q.groups.length) res = run({ groups: q.groups, colors: false, level: false, tu: false, weight: false, loose: true });
        if (res.length) notes.push('On n’a rien pour « ' + dropped.join(' ') + ' » : voici ce qui s’en rapproche le plus.');
        q.dropped = dropped;
      }
      if (!res.length && exps.length > 1) {
        /* Recherche longue (nom complet d'un produit) : les produits qui partagent le plus de mots */
        res = run({ groups: null, colors: false, level: false, tu: false, weight: false, loose: true, minHits: 1 });
        if (res.length) notes.push('Aucun produit ne contient tous les mots : voici les plus proches.');
      }
    }
    var items = res.map(function (r) { return r.it; });

    /* Au mot près : les produits dont le TITRE contient tous les mots tapés passent devant.
       « pro grip jaune » → Tiges Pro Grip Jaune (et pas un filtre « niveau expert ») */
    var lw = q.words || [];
    var interpreted = lw.length && lw.join(' ') !== q.text.join(' ');
    if (lw.length >= 2 || (lw.length === 1 && interpreted && !NOUN[lw[0]] && !MOD[lw[0]])) {
      var lexps = lw.map(function (w, i) { return expand(idx, w, i === lw.length - 1); });
      var L = idx.items.filter(function (it) {
        if (q.max && it.p > q.max) return false;
        if (q.weight != null && (!it.w.length || closestW(it.w, q.weight) > 0)) return false;
        for (var j = 0; j < lexps.length; j++) {
          var s = tokScore(it, lexps[j]);
          if (s !== 30 && s !== 18 && s !== 12) return false;   // présent dans le titre
        }
        return true;
      });
      if (L.length) {
        var pos = {};
        items.forEach(function (it, i) { pos[it.h] = i; });
        L.sort(function (a, b) {
          return (b.a - a.a) || ((a.h in pos ? pos[a.h] : 1e4) - (b.h in pos ? pos[b.h] : 1e4)) ||
            ((G[b.g] ? G[b.g].b : 0) - (G[a.g] ? G[a.g].b : 0)) || bizCmp(a, b);
        });
        var inL = {};
        L.forEach(function (it) { inL[it.h] = 1; });
        items = L.concat(items.filter(function (it) { return !inL[it.h]; }));
        notes = [];
      }
    }
    if (q.cheap) items.sort(function (a, b) { return a.p - b.p; });
    return { q: q, items: items, corrected: corrected, notes: notes };
  }

  /* Suggestion « Vouliez-vous dire » */
  function didYouMean(r) {
    if (!r.corrected.length) return '';
    var s = norm(r.q.raw);
    r.corrected.forEach(function (c) { s = s.replace(new RegExp('\\b' + c[0] + 's?\\b'), c[1]); });
    return s !== norm(r.q.raw) ? s : '';
  }

  /* ------------------------------------------------------------------ *
   * Panier (même mécanique que les cartes de l'accueil)
   * ------------------------------------------------------------------ */
  function htmlOf(html, sel) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
    return el ? el.innerHTML : null;
  }
  function addToCart(id, btn, it) {
    if (!id) return;
    var items = [{ id: parseInt(id, 10), quantity: 1 }];
    /* Mécanique officielle du thème : met à jour le tiroir + le compteur et ouvre le panier */
    var helper = W.xCartHelper;
    if (helper && typeof helper.addItems === 'function') {
      try { helper.addItems(items); flashBtn(btn); return; } catch (e) {}
    }
    var drawer = D.getElementById('CartDrawer');
    var drawerId = drawer && drawer.dataset ? drawer.dataset.sectionId : null;
    var sections = ['cart-icon-bubble'];
    if (drawerId) sections.push(drawerId);
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(((W.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sections })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (btn) btn.removeAttribute('aria-busy');
      if (res.status && res.status >= 400) { if (it) W.location.href = '/products/' + it.h; return; }
      var s = res.sections || {};
      var bubble = D.getElementById('cart-icon-bubble');
      if (bubble && s['cart-icon-bubble']) {
        var b = htmlOf(s['cart-icon-bubble'], '.shopify-section') || htmlOf(s['cart-icon-bubble'], '#cart-icon-bubble');
        if (b != null) bubble.innerHTML = b;
      }
      flashBtn(btn);
      if (drawer && drawerId && s[drawerId]) {
        var d = htmlOf(s[drawerId], '#CartDrawer');
        if (d != null) drawer.innerHTML = d;
        D.dispatchEvent(new CustomEvent('maximize:cart:updated', { detail: { openMiniCart: true } }));
        try { drawer.isOpen = true; } catch (e) {}
        D.dispatchEvent(new CustomEvent('cart:minicart:open'));
      } else {
        toast('Ajouté au panier ✓', '/cart', 'Voir le panier');
      }
    }).catch(function () { if (btn) btn.removeAttribute('aria-busy'); W.location.href = '/cart'; });
  }
  function flashBtn(btn) {
    if (!btn) return;
    btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
  }
  function toast(msg, href, label) {
    var t = D.createElement('div');
    t.className = 'pbs-toast';
    t.innerHTML = esc(msg) + (href ? ' <a href="' + esc(href) + '">' + esc(label) + '</a>' : '');
    D.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 300); }, 3200);
  }

  /* ------------------------------------------------------------------ *
   * Rendu commun
   * ------------------------------------------------------------------ */
  var ICON_SEARCH = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_CART = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.4 11.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.2L21 8H6.2"/><circle cx="9.5" cy="20" r="1.3"/><circle cx="17.5" cy="20" r="1.3"/></svg>';
  var ICON_OK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var ICON_ARROW = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function highlight(title, q) {
    var words = (q && q.text ? q.text : []).filter(function (w) { return w.length > 1; });
    var h = esc(title);
    if (!words.length) return h;
    var src = title.split(/(\s+)/), out = '';
    src.forEach(function (part) {
      var nw = stem(norm(part));
      var hit = nw && words.some(function (w) { return nw.indexOf(w) === 0 || (SYN[w] || []).indexOf(nw) > -1; });
      out += hit ? '<mark>' + esc(part) + '</mark>' : esc(part);
    });
    return out;
  }
  function priceHTML(it) {
    var from = it.px > it.p ? '<small>Dès</small> ' : '';
    var sale = it.ca > it.p;
    return '<span class="pbs-price' + (sale ? ' is-sale' : '') + '">' + from + '<b>' + money(it.p) + '</b>' +
      (sale ? '<s>' + money(it.ca) + '</s>' : '') + '</span>';
  }
  function starsHTML(it) {
    if (!it.rc || !it.r) return '';
    return '<span class="pbs-stars" aria-label="Note ' + String(it.r).replace('.', ',') + ' sur 5"><b>★</b> ' +
      it.r.toFixed(1).replace('.', ',') + ' <span>(' + it.rc + ')</span></span>';
  }

  /* ------------------------------------------------------------------ *
   * Barre de recherche du header
   * ------------------------------------------------------------------ */
  var POPULAR = [
    ['Fléchettes steel', 'fléchettes steel'], ['Fléchettes soft', 'fléchettes soft'], ['Cibles sisal', 'cible sisal'],
    ['Cibles électroniques', 'cible électronique'], ['Ailettes', 'ailettes'], ['Tiges', 'tiges'],
    ['Pointes', 'pointes'], ['Étuis', 'étui'], ['Débutant', 'fléchettes débutant']
  ];
  var BRANDS = ["Target", "Winmau", "Harrows", "Mission", "Unicorn", "Red Dragon", "Bull's", "L-Style", "Granboard", "Cosmo Darts", "One80", "Shot"];

  function recent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]').slice(0, 5); } catch (e) { return []; }
  }
  function pushRecent(q) {
    q = String(q || '').trim();
    if (q.length < 2) return;
    try {
      var r = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      r.unshift(q);
      localStorage.setItem(RECENT_KEY, JSON.stringify(r.slice(0, 6)));
    } catch (e) {}
  }
  function searchUrl(q, extra) { return '/search?q=' + encodeURIComponent(q) + '&type=product' + (extra || ''); }

  function Dropdown(input, drop, opts) {
    var self = this;
    this.input = input; this.drop = drop; this.opts = opts || {};
    this.active = -1; this.timer = null; this.last = null;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', drop.id);
    input.addEventListener('input', function () { self.schedule(); });
    input.addEventListener('focus', function () { self.open(); });
    input.addEventListener('keydown', function (e) { self.key(e); });
    drop.addEventListener('mousedown', function (e) { if (e.target.closest('a,button')) e.preventDefault(); });
    drop.addEventListener('click', function (e) {
      var term = self.input.value.trim();
      var add = e.target.closest('[data-pbs-add]');
      if (add) { e.preventDefault(); trackAdd(term || '(suggestions)', add, self.opts.src); addToCart(add.getAttribute('data-pbs-add'), add); return; }
      var a = e.target.closest('a[data-pbs-pos]');
      if (a) { self.flushTyped(); trackClick(term || '(suggestions)', a, self.opts.src); }
      var inf = e.target.closest('[data-pbs-info]');
      if (inf) { self.flushTyped(); track('pb_search_info', { search_term: term, page: inf.getAttribute('data-pbs-info'), source: self.opts.src }); }
      var q = e.target.closest('[data-pbs-q]');
      if (q) {
        e.preventDefault();
        var kind = q.getAttribute('data-pbs-kind') || (q.classList.contains('pbs-d__all') ? 'voir_tout' : 'suggestion');
        setFrom(self.opts.src + ':' + kind);
        self.go(q.getAttribute('data-pbs-q'), q.getAttribute('data-pbs-extra') || '');
      }
      var clr = e.target.closest('[data-pbs-clear-recent]');
      if (clr) { e.preventDefault(); try { localStorage.removeItem(RECENT_KEY); } catch (er) {} self.render(); }
    });
  }
  Dropdown.prototype.open = function () {
    var self = this;
    this.isOpen = true;
    this.render();
    if (!IDX) {
      load({ allowStale: true }).then(function () { if (self.isOpen) self.render(); }, function () {});
    }
  };
  Dropdown.prototype.close = function () {
    this.isOpen = false;
    this.drop.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
  };
  Dropdown.prototype.schedule = function () {
    var self = this;
    clearTimeout(this.timer);
    this.timer = setTimeout(function () { self.isOpen = true; self.render(); }, 40);
    clearTimeout(this.typedTimer);
    this.typedTimer = setTimeout(function () { self.flushTyped(); }, 1500);
  };
  /* Ce que les gens tapent (même s'ils ne valident jamais) : 1 événement par terme, après 1,5 s de pause */
  Dropdown.prototype.flushTyped = function () {
    clearTimeout(this.typedTimer);
    var q = this.input.value.trim();
    if (q.length < 2 || !IDX || q.toLowerCase() === this.lastTyped) return;
    this.lastTyped = q.toLowerCase();
    var r = search(IDX, q);
    track('pb_search_typed', { search_term: q, results_count: r.items.length, corrected_term: didYouMean(r), source: this.opts.src });
  };
  Dropdown.prototype.go = function (q, extra) {
    q = String(q || '').trim();
    if (!q) { this.input.focus(); return; }
    this.flushTyped();
    pushRecent(q);
    W.location.href = searchUrl(q, extra);
  };
  Dropdown.prototype.key = function (e) {
    var opts = this.drop.querySelectorAll('[data-pbs-opt]');
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!opts.length) return;
      e.preventDefault();
      this.active = e.key === 'ArrowDown' ? (this.active + 1) % opts.length : (this.active <= 0 ? opts.length - 1 : this.active - 1);
      opts.forEach(function (o, i) { o.classList.toggle('is-active', i === this.active); }.bind(this));
      opts[this.active].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter') {
      if (this.active > -1 && opts[this.active]) { e.preventDefault(); opts[this.active].click(); }
      else { pushRecent(this.input.value); this.flushTyped(); }
    } else if (e.key === 'Escape') {
      this.close();
      if (this.opts.onEscape) this.opts.onEscape();
    }
  };
  Dropdown.prototype.render = function () {
    if (!this.isOpen) return;
    var q = this.input.value.trim(), html = '';
    this.active = -1;
    if (q.length < 2) html = this.emptyHTML();
    else if (!IDX) html = '<div class="pbs-d__loading"><span class="pbs-spin"></span>Recherche…</div>';
    else html = this.resultsHTML(q);
    this.drop.innerHTML = html;
    this.drop.hidden = !html;
    this.input.setAttribute('aria-expanded', html ? 'true' : 'false');
  };
  Dropdown.prototype.emptyHTML = function () {
    var r = recent(), h = '';
    if (r.length) {
      h += '<div class="pbs-d__sec"><p class="pbs-d__lbl">Tes dernières recherches <button type="button" class="pbs-d__clear" data-pbs-clear-recent>Effacer</button></p><div class="pbs-chips">';
      r.forEach(function (x) { h += '<button type="button" class="pbs-chip" data-pbs-opt data-pbs-kind="recente" data-pbs-q="' + esc(x) + '">' + esc(x) + '</button>'; });
      h += '</div></div>';
    }
    h += '<div class="pbs-d__sec"><p class="pbs-d__lbl">Recherches populaires</p><div class="pbs-chips">';
    POPULAR.forEach(function (p) { h += '<button type="button" class="pbs-chip" data-pbs-opt data-pbs-kind="populaire" data-pbs-q="' + esc(p[1]) + '">' + esc(p[0]) + '</button>'; });
    h += '</div></div><div class="pbs-d__sec"><p class="pbs-d__lbl">Marques</p><div class="pbs-chips">';
    BRANDS.forEach(function (b) { h += '<button type="button" class="pbs-chip pbs-chip--brand" data-pbs-opt data-pbs-kind="marque" data-pbs-q="' + esc(b) + '">' + esc(b) + '</button>'; });
    h += '</div></div>';
    if (IDX && this.opts.showBest) {
      var best = IDX.items.filter(function (i) { return i.a && (i.g === 'steel_dart' || i.g === 'soft_dart' || i.g === 'board_sisal' || i.g === 'board_elec'); }).slice(0, 4);
      if (best.length) {
        h += '<div class="pbs-d__sec"><p class="pbs-d__lbl">Les plus vendus</p><div class="pbs-d__prods">';
        best.forEach(function (it, i) { h += prodRow(it, i, null); });
        h += '</div></div>';
      }
    }
    return h;
  };
  /* Liens vers les pages pratiques (livraison, contact, appli de score…) */
  function infoHTML(q, kind) {
    var links = infoLinks(q);
    if (!links.length) return '';
    var h = '<div class="pbs-info' + (kind === 'd' ? ' pbs-info--d' : '') + '">';
    links.forEach(function (x) {
      h += '<a class="pbs-info__a" href="' + esc(x.u) + '"' + (kind === 'd' ? ' data-pbs-opt' : '') + ' data-pbs-info="' + esc(x.u) + '">' +
        '<span class="pbs-info__i" aria-hidden="true">i</span><span>' + esc(x.l) + '</span>' + ICON_ARROW + '</a>';
    });
    return h + '</div>';
  }
  /* Meilleures ventes en stock, variées (2 max par catégorie) */
  function bestSellers(n) {
    if (!IDX) return [];
    /* fléchettes et cibles d'abord, puis accessoires ; le n°1 de chaque catégorie, puis le n°2 */
    var order = ['steel_dart', 'soft_dart', 'board_sisal', 'board_elec', 'pack', 'light', 'case', 'surround', 'mat', 'flight', 'shaft'];
    var list = IDX.items.slice().sort(bizCmp), out = [];
    for (var round = 0; round < 2 && out.length < n; round++) {
      order.forEach(function (g) {
        if (out.length >= n) return;
        var pick = list.filter(function (it) { return it.g === g && it.a && it.i && out.indexOf(it) < 0; })[0];
        if (pick) out.push(pick);
      });
    }
    return out;
  }
  function prodRow(it, i, q) {
    var add = it.vid && it.a
      ? '<button type="button" class="pbs-d__add" data-pbs-add="' + esc(it.vid) + '" aria-label="Ajouter ' + esc(it.t) + ' au panier">' + ICON_CART + '<span class="pbs-ok">' + ICON_OK + '</span></button>'
      : '';
    return '<div class="pbs-d__prod' + (it.a ? '' : ' is-oos') + '">' +
      '<a href="/products/' + esc(it.h) + '" class="pbs-d__link" data-pbs-opt data-pbs-pos="' + (i + 1) + '" data-pbs-h="' + esc(it.h) + '">' +
      '<span class="pbs-d__img">' + (it.i ? '<img src="' + esc(imgUrl(it.i, 140)) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</span>' +
      '<span class="pbs-d__txt"><span class="pbs-d__vendor">' + esc(it.v) + '</span>' +
      '<span class="pbs-d__title">' + highlight(it.t, q) + '</span>' +
      '<span class="pbs-d__meta">' + priceHTML(it) + (it.a ? '' : '<span class="pbs-oos">Épuisé</span>') + '</span></span></a>' + add + '</div>';
  }
  Dropdown.prototype.resultsHTML = function (q) {
    var r = search(IDX, q), items = r.items, h = infoHTML(q, 'd');
    var dym = didYouMean(r);
    if (!items.length) {
      if (h) return h + this.emptyHTML();
      return '<div class="pbs-d__none"><p><b>Dans le placo !</b> Rien pour « ' + esc(q) + ' ».</p>' +
        '<p class="pbs-d__hint">Retente avec un mot plus simple, une marque ou un poids (ex. <i>22g</i>).</p></div>' + this.emptyHTML();
    }
    if (dym) h += '<p class="pbs-d__dym">Résultats pour <b>' + esc(dym) + '</b></p>';
    /* Catégories trouvées */
    var cnt = {};
    items.forEach(function (it) { cnt[it.g] = (cnt[it.g] || 0) + 1; });
    var cats = Object.keys(cnt).sort(function (a, b) { return cnt[b] - cnt[a]; });
    if (cats.length > 1) {
      h += '<div class="pbs-d__sec pbs-d__sec--cats"><div class="pbs-chips">';
      cats.slice(0, 5).forEach(function (g) {
        h += '<button type="button" class="pbs-chip" data-pbs-opt data-pbs-kind="categorie" data-pbs-q="' + esc(q) + '" data-pbs-extra="&cat=' + g + '">' + esc(G[g].l) + ' <span>' + cnt[g] + '</span></button>';
      });
      h += '</div></div>';
    }
    var max = this.opts.max || 6;
    h += '<div class="pbs-d__prods">';
    items.slice(0, max).forEach(function (it, i) { h += prodRow(it, i, r.q); });
    h += '</div>';
    h += '<button type="button" class="pbs-d__all" data-pbs-opt data-pbs-q="' + esc(q) + '"><span>Voir les ' + items.length + ' résultat' + (items.length > 1 ? 's' : '') + ' pour « ' + esc(q) + ' »</span>' + ICON_ARROW + '</button>';
    return h;
  };

  /* Overlay plein écran (mobile) / panneau (desktop compact) — un seul, dans <body> */
  var overlay = null, overlayDD = null, pushed = false;
  function ensureOverlay() {
    if (overlay) return overlay;
    overlay = D.createElement('div');
    overlay.className = 'pbs-ov';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Rechercher');
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="pbs-ov__bg" data-pbs-close></div>' +
      '<div class="pbs-ov__panel">' +
      '<form class="pbs-ov__form" action="/search" method="get" role="search">' +
      '<span class="pbs-ov__icon">' + ICON_SEARCH + '</span>' +
      '<input class="pbs-ov__input" type="search" name="q" placeholder="Fléchettes, cibles, marques…" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="search" aria-label="Rechercher">' +
      '<input type="hidden" name="type" value="product">' +
      '<button type="button" class="pbs-ov__clear" aria-label="Effacer" hidden>' + ICON_X + '</button>' +
      '<button type="button" class="pbs-ov__cancel" data-pbs-close>Annuler</button>' +
      '</form>' +
      '<div class="pbs-ov__drop pbs-d" id="pbs-ov-drop" role="listbox"></div>' +
      '</div>';
    D.body.appendChild(overlay);
    var input = overlay.querySelector('.pbs-ov__input');
    var clear = overlay.querySelector('.pbs-ov__clear');
    overlayDD = new Dropdown(input, overlay.querySelector('.pbs-ov__drop'), { max: 8, showBest: true, onEscape: closeOverlay, src: 'panneau' });
    overlayDD.close = function () {};  // le panneau reste visible tant que l'overlay est ouvert
    input.addEventListener('input', function () { clear.hidden = !input.value; });
    clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; input.focus(); overlayDD.render(); });
    overlay.addEventListener('click', function (e) { if (e.target.closest('[data-pbs-close]')) { e.preventDefault(); closeOverlay(); } });
    overlay.querySelector('form').addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); return; }
      pushRecent(input.value);
    });
    return overlay;
  }
  function openOverlay(prefill) {
    ensureOverlay();
    var input = overlay.querySelector('.pbs-ov__input');
    overlay.hidden = false;
    D.documentElement.classList.add('pbs-lock');
    if (prefill != null) input.value = prefill;
    overlay.querySelector('.pbs-ov__clear').hidden = !input.value;
    input.focus();
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    overlayDD.isOpen = true;
    overlayDD.open();
    if (!pushed && W.history && history.pushState) { history.pushState({ pbsOverlay: 1 }, ''); pushed = true; }
  }
  function closeOverlay(fromPop) {
    if (!overlay || overlay.hidden) return;
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    D.documentElement.classList.remove('pbs-lock');
    if (pushed) { pushed = false; if (!fromPop) history.back(); }
  }
  W.addEventListener('popstate', function () { if (overlay && !overlay.hidden) closeOverlay(true); });

  var uid = 0;
  function initHeader(root) {
    if (root.__pbs) return;
    root.__pbs = true;
    var opener = root.querySelector('[data-pbs-open]');
    var input = root.querySelector('[data-pbs-input]');
    var drop = root.querySelector('[data-pbs-drop]');
    var form = root.querySelector('form');
    var clear = root.querySelector('[data-pbs-clear]');
    if (opener) {
      opener.addEventListener('click', function (e) {
        e.preventDefault();
        openOverlay(input ? input.value : '');
      });
    }
    if (!input || !drop) return;
    if (!drop.id) drop.id = 'pbs-drop-' + (++uid);
    var dd = new Dropdown(input, drop, { max: 6, showBest: false, src: 'barre' });
    /* Petit écran : la barre inline ouvre l'overlay plein écran */
    input.addEventListener('focus', function () {
      if (W.matchMedia('(max-width: 767px)').matches) { dd.close(); input.blur(); openOverlay(input.value); }
    });
    D.addEventListener('click', function (e) { if (!root.contains(e.target)) dd.close(); });
    D.addEventListener('focusin', function (e) { if (!root.contains(e.target)) dd.close(); });
    if (clear) {
      input.addEventListener('input', function () { clear.hidden = !input.value; });
      clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; input.focus(); dd.render(); });
    }
    if (form) form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); return; }
      pushRecent(input.value);
    });
    /* Survol : on prépare l'index avant même le clic */
    root.addEventListener('pointerenter', function () { load({ allowStale: true }).catch(function () {}); }, { once: true });
  }

  /* ------------------------------------------------------------------ *
   * Page /search
   * ------------------------------------------------------------------ */
  function Page(root) {
    this.root = root;
    this.q = root.getAttribute('data-q') || '';
    this.grid = root.querySelector('[data-pbs-grid]');
    this.state = this.readUrl();
    this.shown = PER_PAGE;
    this.interacted = false;
    this.bind();
  }
  Page.prototype.readUrl = function () {
    var u = new URLSearchParams(W.location.search);
    function list(k) { var v = u.get(k); return v ? v.split(',').filter(Boolean) : []; }
    return {
      g: list('cat'), v: list('marque'), w: list('poids').map(parseFloat), c: list('couleur'), n: list('niveau'),
      min: u.get('pmin') ? +u.get('pmin') : null, max: u.get('pmax') ? +u.get('pmax') : null,
      stock: u.get('stock') === '1', sort: u.get('tri') || 'pertinence'
    };
  };
  Page.prototype.writeUrl = function () {
    var s = this.state, u = new URLSearchParams();
    u.set('q', this.q); u.set('type', 'product');
    if (s.g.length) u.set('cat', s.g.join(','));
    if (s.v.length) u.set('marque', s.v.join(','));
    if (s.w.length) u.set('poids', s.w.join(','));
    if (s.c.length) u.set('couleur', s.c.join(','));
    if (s.n.length) u.set('niveau', s.n.join(','));
    if (s.min != null) u.set('pmin', s.min);
    if (s.max != null) u.set('pmax', s.max);
    if (s.stock) u.set('stock', '1');
    if (s.sort !== 'pertinence') u.set('tri', s.sort);
    try { history.replaceState(history.state, '', '/search?' + u.toString()); } catch (e) {}
  };
  Page.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var t = e.target;
      var zero = !(self.base && self.base.length);
      var add = t.closest('[data-pbs-add]');
      if (add) { e.preventDefault(); self.interacted = true; trackAdd(self.q, add, zero ? 'page_zero' : 'page'); addToCart(add.getAttribute('data-pbs-add'), add); return; }
      var link = t.closest('a[data-pbs-pos]');
      if (link) trackClick(self.q, link, zero ? 'page_zero' : 'page');
      var inf = t.closest('[data-pbs-info]');
      if (inf) track('pb_search_info', { search_term: self.q, page: inf.getAttribute('data-pbs-info'), source: zero ? 'page_zero' : 'page' });
      var f = t.closest('[data-pbs-f]');
      if (f) {
        e.preventDefault();
        var fk = f.getAttribute('data-pbs-f'), fv = f.getAttribute('data-pbs-v');
        track('pb_search_filter', { search_term: self.q, filter: { g: 'categorie', v: 'marque', w: 'poids', c: 'couleur', n: 'niveau' }[fk] || fk, filter_value: fk === 'g' && G[fv] ? G[fv].l : fv, action: self.state[fk].indexOf(fk === 'w' ? parseFloat(fv) : fv) > -1 ? 'retrait' : 'ajout' });
        self.toggle(fk, fv); return;
      }
      if (t.closest('[data-pbs-more]')) { e.preventDefault(); self.shown += PER_PAGE; track('pb_search_more', { search_term: self.q, shown: Math.min(self.shown, self.filtered.length), results_count: self.filtered.length }); self.renderGrid(true); return; }
      if (t.closest('[data-pbs-reset]')) { e.preventDefault(); self.reset(); return; }
      if (t.closest('[data-pbs-open-filters]')) { e.preventDefault(); self.sheet(true); return; }
      if (t.closest('[data-pbs-close-filters]')) { e.preventDefault(); self.sheet(false); return; }
      var dym = t.closest('[data-pbs-dym]');
      if (dym) { e.preventDefault(); W.location.href = searchUrl(dym.getAttribute('data-pbs-dym')); }
    });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-pbs-sort]')) { self.state.sort = t.value; self.interacted = true; track('pb_search_sort', { search_term: self.q, sort: t.value }); self.apply(); }
      if (t.matches('[data-pbs-stock]')) { self.state.stock = t.checked; self.interacted = true; track('pb_search_filter', { search_term: self.q, filter: 'stock', filter_value: 'en stock', action: t.checked ? 'ajout' : 'retrait' }); self.apply(); }
    });
    var pt = null;
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (!t.matches('[data-pbs-pmin],[data-pbs-pmax]')) return;
      clearTimeout(pt);
      pt = setTimeout(function () {
        var v = t.value === '' ? null : Math.max(0, parseFloat(t.value) || 0);
        if (t.matches('[data-pbs-pmin]')) self.state.min = v; else self.state.max = v;
        self.interacted = true;
        track('pb_search_filter', { search_term: self.q, filter: 'prix', filter_value: (self.state.min != null ? self.state.min : 0) + '-' + (self.state.max != null ? self.state.max : ''), action: 'ajout' });
        self.apply(true);
      }, 450);
    });
    var form = root.querySelector('[data-pbs-refine]');
    if (form) form.addEventListener('submit', function (e) {
      var v = form.querySelector('input[name="q"]').value.trim();
      if (!v) { e.preventDefault(); return; }
      pushRecent(v);
    });
    D.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.sheet(false); });
    /* Chargement automatique en bas de grille */
    if ('IntersectionObserver' in W) {
      this.io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting && self.filtered && self.shown < self.filtered.length && self.autoMore) { self.shown += PER_PAGE; self.renderGrid(true); } });
      }, { rootMargin: '600px 0px' });
    }
  };
  Page.prototype.sheet = function (open) {
    var s = this.root.querySelector('[data-pbs-sheet]');
    if (!s) return;
    if (open) { s.classList.add('is-open'); D.documentElement.classList.add('pbs-lock'); }
    else if (s.classList.contains('is-open')) { s.classList.remove('is-open'); D.documentElement.classList.remove('pbs-lock'); }
  };
  Page.prototype.toggle = function (k, v) {
    var arr = this.state[k];
    if (k === 'w') v = parseFloat(v);
    var i = arr.indexOf(v);
    if (i > -1) arr.splice(i, 1); else arr.push(v);
    this.interacted = true;
    this.apply(true);
  };
  Page.prototype.reset = function () {
    this.state = { g: [], v: [], w: [], c: [], n: [], min: null, max: null, stock: false, sort: this.state.sort };
    var a = this.root.querySelector('[data-pbs-pmin]'), b = this.root.querySelector('[data-pbs-pmax]');
    if (a) a.value = ''; if (b) b.value = '';
    this.apply(true);
  };
  Page.prototype.start = function () {
    var self = this;
    if (!this.q) { this.renderEmptyQuery(); return; }
    load({ fresh: true, allowStale: true }).then(function (idx) { self.run(idx); }, function () { self.fail(); });
    D.addEventListener('pbsearch:index', function (e) {
      if (!self.interacted && W.scrollY < 150) self.run(e.detail, true);
    });
  };
  Page.prototype.run = function (idx, silent) {
    this.res = search(idx, this.q);
    this.base = this.res.items;
    this.apply(false, silent);
    if (!silent) {
      var q = this.res.q, nav = performance && performance.timing ? performance.timing.navigationStart : 0;
      var data = {
        search_term: this.q,
        search_term_norm: norm(this.q),
        results_count: this.base.length,
        corrected_term: didYouMean(this.res),
        relaxed: this.res.notes.length ? 'oui' : 'non',
        detected_category: q.groups.map(function (g) { return G[g] ? G[g].l : g; }).join(', '),
        detected_weight: q.weight != null ? q.weight : '',
        first_product: this.base[0] ? this.base[0].h : '',
        source: takeFrom() || (document.referrer.indexOf(location.host) > -1 ? 'formulaire' : 'externe'),
        load_ms: nav ? Date.now() - nav : 0
      };
      track('pb_search', data);
      if (!this.base.length) track('pb_search_zero', data);
      pushRecent(this.q);
    }
  };
  function passes(it, s, skip) {
    if (skip !== 'g' && s.g.length && s.g.indexOf(it.g) < 0) return false;
    if (skip !== 'v' && s.v.length && s.v.indexOf(it.v) < 0) return false;
    if (skip !== 'w' && s.w.length && !it.w.some(function (w) { return s.w.indexOf(w) > -1; })) return false;
    if (skip !== 'c' && s.c.length && !s.c.some(function (c) { return it.c[c]; })) return false;
    if (skip !== 'n' && s.n.length && !s.n.some(function (n) { return it.n.indexOf(n) > -1; })) return false;
    if (s.min != null && it.p < s.min * 100) return false;
    if (s.max != null && it.p > s.max * 100) return false;
    if (s.stock && !it.a) return false;
    return true;
  }
  Page.prototype.apply = function (resetPaging, silent) {
    var s = this.state, list = this.base || [];
    var f = list.filter(function (it) { return passes(it, s); });
    var sorters = {
      ventes: function (a, b) { return (b.a - a.a) || a.rank - b.rank; },
      prix_asc: function (a, b) { return (b.a - a.a) || a.p - b.p; },
      prix_desc: function (a, b) { return (b.a - a.a) || b.p - a.p; },
      nouveautes: function (a, b) { return b.d - a.d; },
      notes: function (a, b) { return (b.r * Math.min(b.rc, 5)) - (a.r * Math.min(a.rc, 5)) || a.rank - b.rank; }
    };
    if (sorters[s.sort]) f = f.slice().sort(sorters[s.sort]);
    this.filtered = f;
    if (resetPaging) this.shown = PER_PAGE;
    this.writeUrl();
    this.renderHead();
    this.renderFacets();
    this.renderGrid(false);
    if (resetPaging && !silent) {
      var top = this.root.querySelector('[data-pbs-bar]');
      if (top && top.getBoundingClientRect().top < 0) W.scrollTo({ top: W.scrollY + top.getBoundingClientRect().top - 80, behavior: 'smooth' });
    }
  };
  Page.prototype.renderHead = function () {
    var r = this.res, n = this.filtered.length, total = this.base.length;
    var title = this.root.querySelector('[data-pbs-title]');
    var note = this.root.querySelector('[data-pbs-note]');
    var count = this.root.querySelectorAll('[data-pbs-count]');
    var ih = infoHTML(this.q, 'p');
    if (title) title.innerHTML = total
      ? '<span>' + total + ' résultat' + (total > 1 ? 's' : '') + ' pour</span> « ' + esc(this.q) + ' »'
      : ih ? '<span>Pour</span> « ' + esc(this.q) + ' »<span>, c’est par ici :</span>'
        : '<span>0 résultat pour</span> « ' + esc(this.q) + ' »';
    var info = this.root.querySelector('[data-pbs-info]');
    if (info) { info.innerHTML = ih; info.hidden = !ih; }
    var msgs = [];
    var dym = didYouMean(r);
    if (dym && total) msgs.push('Résultats pour <b>' + esc(dym) + '</b> (orthographe corrigée).');
    r.notes.forEach(function (m) { msgs.push(esc(m)); });
    if (note) { note.innerHTML = msgs.join('<br>'); note.hidden = !msgs.length; }
    count.forEach(function (c) { c.textContent = n + ' produit' + (n > 1 ? 's' : ''); });
    try { D.title = 'Recherche « ' + this.q + ' » (' + total + ') – Pleine Bull'; } catch (e) {}
  };
  Page.prototype.facetData = function () {
    var s = this.state, base = this.base || [], out = { g: {}, v: {}, w: {}, c: {}, n: {}, pmin: Infinity, pmax: 0 };
    base.forEach(function (it) {
      if (passes(it, s, 'g')) out.g[it.g] = (out.g[it.g] || 0) + 1;
      if (passes(it, s, 'v') && it.v) out.v[it.v] = (out.v[it.v] || 0) + 1;
      if (passes(it, s, 'w') && (it.g === 'steel_dart' || it.g === 'soft_dart')) it.w.forEach(function (w) { out.w[w] = (out.w[w] || 0) + 1; });
      if (passes(it, s, 'c')) Object.keys(it.c).forEach(function (c) { out.c[c] = (out.c[c] || 0) + 1; });
      if (passes(it, s, 'n') && it.n) ['debutant', 'intermediaire', 'confirme', 'expert'].forEach(function (l) { if (it.n.indexOf(l) > -1) out.n[l] = (out.n[l] || 0) + 1; });
      out.pmin = Math.min(out.pmin, it.p); out.pmax = Math.max(out.pmax, it.p);
    });
    return out;
  };
  Page.prototype.renderFacets = function () {
    var s = this.state, fd = this.facetData(), self = this;
    /* Rangée de catégories (au-dessus de la grille) */
    var chips = this.root.querySelector('[data-pbs-cats]');
    var gk = Object.keys(fd.g).sort(function (a, b) { return fd.g[b] - fd.g[a]; });
    if (chips) {
      if (gk.length > 1 || s.g.length) {
        var h = '<button type="button" class="pbs-cat' + (s.g.length ? '' : ' is-on') + '" data-pbs-reset-cats>Tout <span>' + (this.base || []).filter(function (it) { return passes(it, s, 'g'); }).length + '</span></button>';
        gk.forEach(function (g) {
          h += '<button type="button" class="pbs-cat' + (s.g.indexOf(g) > -1 ? ' is-on' : '') + '" data-pbs-f="g" data-pbs-v="' + g + '">' + esc(G[g].l) + ' <span>' + fd.g[g] + '</span></button>';
        });
        chips.innerHTML = h; chips.hidden = false;
        var all = chips.querySelector('[data-pbs-reset-cats]');
        if (all) all.addEventListener('click', function () { self.state.g = []; self.interacted = true; self.apply(true); });
      } else { chips.innerHTML = ''; chips.hidden = true; }
    }
    /* Panneau de filtres */
    var box = this.root.querySelector('[data-pbs-facets]');
    if (!box) return;
    function group(title, key, entries, label, open) {
      if (entries.length < 2 && !s[key].length) return '';
      var hh = '<details class="pbs-fg"' + (open ? ' open' : '') + '><summary>' + title + (s[key].length ? ' <em>' + s[key].length + '</em>' : '') + '</summary><div class="pbs-fg__opts' + (key === 'w' || key === 'c' ? ' pbs-fg__opts--pills' : '') + '">';
      entries.forEach(function (e) {
        var on = s[key].indexOf(e[0]) > -1;
        hh += '<button type="button" class="pbs-opt' + (on ? ' is-on' : '') + (key === 'c' ? ' pbs-opt--c pbs-c-' + e[0] : '') + '" data-pbs-f="' + key + '" data-pbs-v="' + esc(e[0]) + '" aria-pressed="' + on + '">' +
          '<span class="pbs-opt__box"></span><span class="pbs-opt__l">' + esc(label ? label(e[0]) : e[0]) + '</span><span class="pbs-opt__n">' + e[1] + '</span></button>';
      });
      return hh + '</div></details>';
    }
    function entries(o, sortFn) {
      return Object.keys(o).map(function (k) { return [k, o[k]]; }).sort(sortFn || function (a, b) { return b[1] - a[1]; });
    }
    var html = '';
    var we = entries(fd.w, function (a, b) { return parseFloat(a[0]) - parseFloat(b[0]); }).map(function (e) { return [parseFloat(e[0]), e[1]]; });
    html += group('Poids', 'w', we, function (w) { return String(w).replace('.', ',') + ' g'; }, true);
    html += group('Marque', 'v', entries(fd.v), null, true);
    html += group('Couleur', 'c', entries(fd.c), function (c) { return c.charAt(0).toUpperCase() + c.slice(1); }, false);
    html += group('Niveau', 'n', entries(fd.n), function (n) { return { debutant: 'Débutant', intermediaire: 'Intermédiaire', confirme: 'Confirmé', expert: 'Expert' }[n] || n; }, false);
    var lo = isFinite(fd.pmin) ? Math.floor(fd.pmin / 100) : 0, hi = Math.ceil(fd.pmax / 100);
    html += '<details class="pbs-fg" open><summary>Prix</summary><div class="pbs-price-f">' +
      '<label><span>Min</span><input type="number" inputmode="numeric" min="0" placeholder="' + lo + '" value="' + (s.min != null ? s.min : '') + '" data-pbs-pmin> €</label>' +
      '<label><span>Max</span><input type="number" inputmode="numeric" min="0" placeholder="' + hi + '" value="' + (s.max != null ? s.max : '') + '" data-pbs-pmax> €</label></div></details>';
    html += '<label class="pbs-stock"><input type="checkbox" data-pbs-stock' + (s.stock ? ' checked' : '') + '><span>En stock uniquement</span></label>';
    /* Garder le focus sur un champ prix pendant la saisie */
    var foc = D.activeElement && box.contains(D.activeElement) && D.activeElement.matches('input[type=number]') ? (D.activeElement.hasAttribute('data-pbs-pmin') ? 'pmin' : 'pmax') : null;
    var openState = {};
    box.querySelectorAll('details').forEach(function (d) { openState[d.querySelector('summary').firstChild.textContent.trim()] = d.open; });
    box.innerHTML = html;
    box.querySelectorAll('details').forEach(function (d) {
      var k = d.querySelector('summary').firstChild.textContent.trim();
      if (k in openState) d.open = openState[k];
    });
    if (foc) { var el = box.querySelector('[data-pbs-' + foc + ']'); if (el) { el.focus(); var v = el.value; el.value = ''; el.value = v; } }
    /* Filtres actifs + compteur */
    var act = [], labels = { g: function (v) { return G[v].l; }, w: function (v) { return String(v).replace('.', ',') + ' g'; }, c: function (v) { return v.charAt(0).toUpperCase() + v.slice(1); }, n: function (v) { return { debutant: 'Débutant', intermediaire: 'Intermédiaire', confirme: 'Confirmé', expert: 'Expert' }[v] || v; }, v: function (v) { return v; } };
    ['g', 'v', 'w', 'c', 'n'].forEach(function (k) { s[k].forEach(function (v) { act.push('<button type="button" class="pbs-pill" data-pbs-f="' + k + '" data-pbs-v="' + esc(v) + '">' + esc(labels[k](v)) + ICON_X + '</button>'); }); });
    if (s.min != null || s.max != null) act.push('<span class="pbs-pill pbs-pill--plain">' + (s.min != null ? s.min : 0) + ' – ' + (s.max != null ? s.max + ' €' : '∞') + '</span>');
    if (s.stock) act.push('<span class="pbs-pill pbs-pill--plain">En stock</span>');
    var actBox = this.root.querySelector('[data-pbs-active]');
    if (actBox) {
      actBox.innerHTML = act.length ? act.join('') + '<button type="button" class="pbs-pill pbs-pill--reset" data-pbs-reset>Tout effacer</button>' : '';
      actBox.hidden = !act.length;
    }
    var nf = act.length;
    this.root.querySelectorAll('[data-pbs-nfilters]').forEach(function (b) { b.textContent = nf ? '(' + nf + ')' : ''; });
    var sort = this.root.querySelector('[data-pbs-sort]');
    if (sort) sort.value = s.sort;
  };
  function cardHTML(it, i, q) {
    var badges = '';
    if (!it.a) badges += '<span class="pbs-badge pbs-badge--oos">Épuisé</span>';
    else if (it.ca > it.p) badges += '<span class="pbs-badge pbs-badge--sale">-' + Math.round((1 - it.p / it.ca) * 100) + ' %</span>';
    else if (it.d && (Date.now() / 1000 - it.d) < 30 * 86400) badges += '<span class="pbs-badge pbs-badge--new">Nouveau</span>';
    var w = (it.g === 'steel_dart' || it.g === 'soft_dart') && it.w.length === 1 ? '<span class="pbs-card__w">' + String(it.w[0]).replace('.', ',') + ' g</span>' : '';
    var eager = i < 4;
    var img = it.i
      ? '<img src="' + esc(imgUrl(it.i, 360)) + '" srcset="' + [180, 260, 360, 500].map(function (x) { return esc(imgUrl(it.i, x)) + ' ' + x + 'w'; }).join(', ') + '" sizes="(min-width: 1280px) 220px, (min-width: 1024px) 22vw, (min-width: 640px) 31vw, 47vw" alt="' + esc(it.t) + '" width="360" height="360"' + (eager ? ' fetchpriority="' + (i < 2 ? 'high' : 'auto') + '"' : ' loading="lazy"') + ' decoding="async">'
      : '';
    var btn;
    if (it.vid && it.a) btn = '<button type="button" class="pbs-btn" data-pbs-add="' + esc(it.vid) + '" aria-label="Ajouter ' + esc(it.t) + ' au panier">' + ICON_CART + '<span class="pbs-btn__t">Ajouter</span><span class="pbs-ok">' + ICON_OK + '</span></button>';
    else if (it.a) btn = '<a class="pbs-btn pbs-btn--ghost" href="/products/' + esc(it.h) + '">Choisir</a>';
    else btn = '<a class="pbs-btn pbs-btn--ghost" href="/products/' + esc(it.h) + '">M’alerter</a>';
    var url = '/products/' + esc(it.h);
    return '<li class="pbs-card' + (it.a ? '' : ' is-oos') + '">' +
      '<a class="pbs-card__media" href="' + url + '" data-pbs-pos="' + (i + 1) + '" data-pbs-h="' + esc(it.h) + '" tabindex="-1" aria-hidden="true">' + img + '<span class="pbs-badges">' + badges + '</span></a>' +
      '<div class="pbs-card__body">' +
      '<span class="pbs-card__vendor">' + esc(it.v) + w + '</span>' +
      '<a class="pbs-card__title" href="' + url + '" data-pbs-pos="' + (i + 1) + '" data-pbs-h="' + esc(it.h) + '">' + highlight(it.t, q) + '</a>' +
      starsHTML(it) +
      '<div class="pbs-card__foot">' + priceHTML(it) + btn + '</div>' +
      '</div></li>';
  }
  Page.prototype.renderGrid = function (append) {
    var f = this.filtered || [], q = this.res ? this.res.q : null, self = this;
    var grid = this.grid, more = this.root.querySelector('[data-pbs-morebox]');
    var empty = this.root.querySelector('[data-pbs-empty]');
    this.root.classList.remove('is-loading');
    if (!this.base.length) { grid.innerHTML = ''; if (more) more.innerHTML = ''; this.renderZero(); return; }
    if (empty) empty.hidden = true;
    this.root.querySelector('[data-pbs-layout]').hidden = false;
    if (!f.length) {
      grid.innerHTML = '<li class="pbs-nofilter"><p>Aucun produit avec ces filtres.</p><button type="button" class="pbs-btn pbs-btn--ghost" data-pbs-reset>Effacer les filtres</button></li>';
      if (more) more.innerHTML = '';
      return;
    }
    var from = append ? grid.children.length : 0, to = Math.min(this.shown, f.length), html = '';
    for (var i = from; i < to; i++) html += cardHTML(f[i], i, q);
    if (append) grid.insertAdjacentHTML('beforeend', html); else grid.innerHTML = html;
    if (more) {
      if (to < f.length) {
        more.innerHTML = '<p class="pbs-more__p">' + to + ' sur ' + f.length + ' produits</p><div class="pbs-more__bar"><span style="width:' + Math.round(to / f.length * 100) + '%"></span></div>' +
          '<button type="button" class="pbs-btn pbs-btn--more" data-pbs-more>Voir plus de produits</button>';
        /* après un premier clic, la suite se charge toute seule en défilant */
        if (this.io) { this.io.disconnect(); this.io.observe(more); }
        this.autoMore = this.shown > PER_PAGE;
      } else {
        more.innerHTML = f.length > PER_PAGE ? '<p class="pbs-more__p">Tu as vu les ' + f.length + ' produits.</p>' : '';
        if (this.io) this.io.disconnect();
      }
    }
  };
  Page.prototype.renderZero = function () {
    var empty = this.root.querySelector('[data-pbs-empty]');
    this.root.querySelector('[data-pbs-layout]').hidden = true;
    var cats = this.root.querySelector('[data-pbs-cats]'); if (cats) cats.hidden = true;
    var bar = this.root.querySelector('[data-pbs-bar]'); if (bar) bar.hidden = true;
    if (!empty) return;
    var noQuery = !this.q, h = '', hasInfo = this.q && infoLinks(this.q).length;
    var go = ' onclick="try{sessionStorage.setItem(\'pb_search_from\',\'zero:populaire\')}catch(e){}"';
    if (noQuery) {
      h += '<p class="pbs-zero__t">Tape un produit, une marque ou un poids.</p>';
    } else if (hasInfo) {
      h += '<p class="pbs-zero__h">Et si tu cherchais du matériel, voici de quoi viser juste.</p>';
    } else {
      /* Fléchette plantée dans le mur, à côté de la cible */
      h += '<div class="pbs-miss" aria-hidden="true"><svg viewBox="0 0 220 120" width="220" height="120">' +
        '<rect x="0" y="0" width="220" height="120" rx="14" fill="#efece6"/>' +
        '<path d="M0 40h220M0 80h220M55 0v40M165 0v40M110 40v40M30 80v40M140 80v40" stroke="#e1ddd4" stroke-width="2"/>' +
        '<circle cx="78" cy="60" r="44" fill="#1B2A4A"/><circle cx="78" cy="60" r="35" fill="#f4efe3"/><circle cx="78" cy="60" r="26" fill="#1B2A4A"/>' +
        '<circle cx="78" cy="60" r="17" fill="#f4efe3"/><circle cx="78" cy="60" r="8" fill="#0f8a4b"/><circle cx="78" cy="60" r="3.5" fill="#E30613"/>' +
        '<g class="pbs-miss__dart"><path d="M168 30l-14 12" stroke="#8a8f99" stroke-width="2.5" stroke-linecap="round"/>' +
        '<path d="M170 28l18-16" stroke="#1B2A4A" stroke-width="6" stroke-linecap="round"/>' +
        '<path d="M186 14l8-7 14 2-6 6zM186 14l8-7-2 14-6-1z" fill="#E30613"/></g>' +
        '<path d="M150 46l4-4M150 38l3 1M158 48l-1 3" stroke="#b9b2a5" stroke-width="2" stroke-linecap="round"/></svg></div>';
      h += '<p class="pbs-zero__t">Tu as visé « ' + esc(this.q) + ' »… c’est le placo qui a pris&nbsp;!</p>' +
        '<p class="pbs-zero__h">Aucun produit ne correspond. Pas de panique, même les pros ratent un double. ' +
        'Retente avec un mot plus simple (« fléchettes », « cible »), une marque ou un poids comme <i>22g</i>.</p>';
      var sug = suggestWords(this.q);
      if (sug.length) {
        h += '<p class="pbs-d__lbl">Tu voulais peut-être viser</p><div class="pbs-chips pbs-chips--center">';
        sug.forEach(function (s) { h += '<a class="pbs-chip pbs-chip--sug" href="' + searchUrl(s) + '" onclick="try{sessionStorage.setItem(\'pb_search_from\',\'zero:suggestion\')}catch(e){}">' + esc(s) + '</a>'; });
        h += '</div>';
      }
    }
    /* Les best-sellers d'abord (c'est ce qui vend), les recherches populaires ensuite */
    var best = bestSellers(8);
    if (best.length) {
      h += '<div class="pbs-zero__bestbox"><p class="pbs-zero__best">Nos valeurs sûres</p>' +
        '<p class="pbs-zero__bestsub">Elles, elles ne ratent jamais la cible : les plus vendues du moment.</p><ul class="pbs-grid">';
      best.forEach(function (it, i) { h += cardHTML(it, i, null); });
      h += '</ul></div>';
    }
    h += '<p class="pbs-d__lbl pbs-zero__pop">Les recherches qui font mouche</p><div class="pbs-chips pbs-chips--center">';
    POPULAR.forEach(function (p) { h += '<a class="pbs-chip" href="' + searchUrl(p[1]) + '"' + go + '>' + esc(p[0]) + '</a>'; });
    h += '</div>';
    h += '<p class="pbs-zero__help">Tu cherches un modèle précis&nbsp;? <a href="/pages/contact">Écris-nous</a>, on peut souvent le commander pour toi.</p>';
    empty.innerHTML = h;
    empty.hidden = false;
  };
  /* Mots du catalogue les plus proches de ce qui a été tapé (correction large) */
  function suggestWords(raw) {
    if (!IDX) return [];
    var out = [], seen = {};
    norm(raw).split(' ').map(stem).filter(function (w) { return w.length >= 4 && !/\d/.test(w) && !STOP[w]; })
      .sort(function (a, b) { return b.length - a.length; }).slice(0, 2).forEach(function (w) {
        var max = w.length >= 6 ? 2 : 1, cands = [];
        IDX.vlist.forEach(function (t) {
          if (t.length < 4 || /\d/.test(t) || seen[t]) return;
          var d = dist(w, t, max);
          if (d <= max) cands.push([t, d, IDX.vocab[t]]);
        });
        cands.sort(function (a, b) { return a[1] - b[1] || b[2] - a[2]; }).slice(0, 3).forEach(function (c) { seen[c[0]] = 1; out.push(c[0]); });
      });
    return out.slice(0, 4);
  }
  Page.prototype.renderEmptyQuery = function () {
    this.res = { q: parse(''), items: [], corrected: [], notes: [] };
    this.base = [];
    var title = this.root.querySelector('[data-pbs-title]');
    if (title) title.textContent = 'Que cherches-tu ?';
    var self = this;
    load({ allowStale: true }).then(function () { self.renderZero(); self.root.classList.remove('is-loading'); }, function () {});
    var input = this.root.querySelector('[data-pbs-refine] input[name="q"]');
    if (input) input.focus();
  };
  Page.prototype.fail = function () {
    /* Index indisponible : message de secours avec les catégories */
    this.root.classList.remove('is-loading');
    track('pb_search_error', { search_term: this.q });
    var fb = this.root.querySelector('[data-pbs-fallback]');
    var bar = this.root.querySelector('[data-pbs-bar]');
    if (bar) bar.hidden = true;
    if (fb) { fb.hidden = false; this.root.querySelector('[data-pbs-layout]').hidden = true; }
  };

  /* ------------------------------------------------------------------ *
   * Démarrage
   * ------------------------------------------------------------------ */
  /* Envoi des formulaires de recherche : géré ici en tout premier (phase de capture sur window),
     pour passer devant l'ancien bloqueur de theme.js et marcher avec la touche « OK » d'Android. */
  W.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('.pbs-h__form, .pbs-ov__form, [data-pbs-refine]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var inp = f.querySelector('input[name="q"]');
    var q = inp ? inp.value.trim() : '';
    if (!q) { if (inp) inp.focus(); return; }
    pushRecent(q);
    setFrom((f.matches('.pbs-ov__form') ? 'panneau' : f.matches('[data-pbs-refine]') ? 'page' : 'barre') + ':entree');
    W.location.href = searchUrl(q);
  }, true);

  function init() {
    try { localStorage.removeItem('pb_search_idx_v2'); } catch (e) {}
    D.querySelectorAll('[data-pbs-header]').forEach(initHeader);
    var page = D.querySelector('[data-pbs-page]');
    if (page && !page.__pbs) { page.__pbs = true; new Page(page).start(); }
    /* Préchargement discret de l'index quand le navigateur est libre */
    if (!page) {
      W.addEventListener('load', function () {
        var conn = navigator.connection;
        if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
        var c = readCache();
        if (c && Date.now() - c.t < TTL) return;
        var go = function () { load().catch(function () {}); };
        setTimeout(function () { (W.requestIdleCallback || setTimeout)(go, { timeout: 4000 }); }, 2500);
      });
    }
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
  D.addEventListener('shopify:section:load', init);

  W.PBSearch = { load: load, search: function (q) { return IDX ? search(IDX, q) : null; }, parse: parse, norm: norm, open: openOverlay };
})();
